import { createServer, Model } from "miragejs";

const LANGUAGES = [
  { language: "English", lang_code: "EN" },
  { language: "Spanish", lang_code: "ES" },
  { language: "Greek", lang_code: "GR" },
];

export function startMirageServer() {
  createServer({
    models: {
      languages: Model.extend(),
      skills: Model.extend(),
      jobs: Model.extend(),
      global_search_results_skills: Model.extend(),
      global_search_results_jobs: Model.extend(),
      skillDetails: Model.extend(),
      jobDetails: Model,
      scope: Model,
      trendingJobs: Model.extend(),
      sectors: Model.extend(),
      periods: Model.extend(),
    },

    seeds(server) {
      server.db.loadData({
        languages: LANGUAGES,
      });
    },
    routes() {
      //intercepting requests' prefix
      this.urlPrefix = process.env.REACT_APP_API_ENDPOINT;

      //allowing requests to execute w/o intercepting them
      this.passthrough("https://login.microsoftonline.com/**");
      this.passthrough("https://localhost:5001/identity/**");
      this.passthrough("/skills/**");
      this.passthrough("/jobroles/**");

      this.get("/insights/sectors", (schema) => {
        return schema.db.sectors;
      });

      this.get("/insights/periods", (schema) => {
        return schema.db.periods;
      });

      this.get("/globalSearch/skills/", (schema, request) => {
        let args = request.queryParams;
        return schema.db.global_search_results_skills.where((res) =>
          res.value
            .toLocaleLowerCase()
            .includes(args.searchTerm.toLocaleLowerCase())
        );
      });

      this.get("/globalSearch/jobs/", (schema, request) => {
        let args = request.queryParams;
        return schema.db.global_search_results_jobs.where((res) =>
          res.value
            .toLocaleLowerCase()
            .includes(args.searchTerm.toLocaleLowerCase())
        );
      });

      this.get("home/highlights", () => {
        return {
          sectors: { count: 5, updateCount: 2, updateMonthInterval: 2 },
          jobs: { count: 1540, updateCount: 34, updateMonthInterval: 2 },
          skills: { count: 1540, updateCount: 12, updateMonthInterval: 4 },
          organizations: { count: 820, updateCount: 4, updateMonthInterval: 3 },
        };
      });

      // this.get("skills/trending", (schema, request) => {
      //   let topSkills = schema.db.skills.slice(0, request.queryParams.count ?? 30).map((skill) => {
      //     return { id: skill.id, name: skill.name, rankTrend: skill.trend };
      //   });
      //   return topSkills;

      this.get("/jobs/trending", (schema, request) => {
        let args = request.queryParams;
        let trendingJobsData = schema.db.trendingJobs;
        let data = JSON.parse(JSON.stringify(trendingJobsData[0]));
        if (args.count > 10) {
          for (let index = 10; index < args.count; index++) {
            const element = {
              name: "More " + index,
              percentage: Math.floor(Math.random() * 4).toFixed(2),
              sectorName: "Banking",
            };
            data.trendingJobs.push(element);
          }
        }
        if (args.showPrevMonths === "true") {
          const chartData = data.trendingJobs.map((job) => ({
            ...job,
            previous: Math.floor(Math.random() * 4).toFixed(2),
          }));
          data.trendingJobs = chartData;
        }
        return data;
      });
    },
  });
}

// function Match(filterModel, entity) {
//   return Object.keys(filterModel).every((key) =>
//     filterModel[key].values.includes(entity[key].toString())
//   );
// }

// function Comparer(propertyA, propertyB, sortOrder) {
//   if (typeof propertyA === "string") {
//     propertyA = propertyA.toUpperCase();
//     propertyB = propertyB.toUpperCase();
//   }
//   if (sortOrder === "asc") {
//     if (propertyA < propertyB) {
//       return -1;
//     }
//     if (propertyA > propertyB) {
//       return 1;
//     }
//   }

//   if (sortOrder === "desc") {
//     if (propertyA < propertyB) {
//       return 1;
//     }
//     if (propertyA > propertyB) {
//       return -1;
//     }
//   }
//   return 0;
// }
